import React from 'react';
import LocalModal from 'components/base/local-modal';
import { ReactComponent as WhatsappIcon } from 'assets/icons/whatsapp-icon.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone-icon.svg';
import { CopyIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
import { copyTextToClipboard } from 'utils/functions';

type Props = {
  open: boolean;
  onClose: () => void;
};

const ContactSupportModal = (props: Props) => {
  const { open, onClose } = props;
  const { activeCompany } = useDashboardContext();

  const fcbRep = activeCompany.fc_business_cs_reps?.[0]?.cs_rep;

  const CONTACT_METHODS = [
    {
      icon: <WhatsappIcon />,
      title: `Text ${fcbRep?.first_name ?? 'N/A'} ${fcbRep?.last_name ?? ''}`,
      contact: fcbRep?.phone_number ?? '',
      url: `https://wa.me/${fcbRep?.phone_number}`,
      onCopy: () =>
        copyTextToClipboard(fcbRep?.phone_number ?? '', () =>
          toast(<ToastMessage type='success' message='Copied' />)
        )
    },
    {
      icon: <PhoneIcon />,
      title: `Call ${fcbRep?.first_name ?? ''} ${fcbRep?.last_name ?? ''}`,
      contact: fcbRep?.phone_number ?? '',
      url: `tel:${fcbRep?.phone_number}`,
      onCopy: () =>
        copyTextToClipboard(fcbRep?.phone_number ?? '', () =>
          toast(<ToastMessage type='success' message='Copied' />)
        )
    }
  ];

  return (
    <LocalModal isOpen={open} onRequestClose={onClose}>
      <div className='flex flex-col gap-6'>
        <p className='text-lg font-medium text-center'>Support</p>
        <ul className='flex flex-col gap-4'>
          {CONTACT_METHODS.map((method, index) => (
            <div
              key={index}
              onClick={() => window.open(method.url, '_blank')}
              className='flex items-center gap-2 p-3 rounded-md border border-[#EFF0F0] cursor-pointer'>
              <span className='w-[30px] h-[30px] flex items-center justify-center rounded-full bg-[#F2F2F3] [&_svg]:w-4 [&_svg]:h-4'>
                {method.icon}
              </span>
              <p className='text-sm'>{method.title}</p>
              <p className='text-xs font-medium ml-auto'>{method.contact}</p>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  method.onCopy();
                }}>
                <CopyIcon />
              </button>
            </div>
          ))}
        </ul>
      </div>
    </LocalModal>
  );
};

export default ContactSupportModal;
